import { Controller } from "@hotwired/stimulus"

// One client-side filter for a rendered list: rows carry data-kind and
// data-search, pills name a kind (or "all" / "unread"), and the search box
// matches text or, from three digits, a number. The conversation list and
// the Address Book share it. The segment param stays server-side for deep
// links; a pill tap here only toggles rows.
export default class extends Controller {
  static targets = ["list", "empty", "search", "pill"]
  static values = { segment: { type: String, default: "all" } }

  connect() { this.apply() }

  choose(event) {
    this.segmentValue = event.currentTarget.dataset.segment || "all"
    this.pillTargets.forEach((p) => p.classList.toggle("is-active", p.dataset.segment === this.segmentValue))
    this.apply()
  }

  filter() { this.apply() }

  apply() {
    const q = (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase()
    const digits = q.replace(/\D/g, "")
    let shown = 0
    this.rows().forEach((row) => {
      const inSegment = this.segmentValue === "all"
        || (this.segmentValue === "unread" && row.dataset.unread === "true")
        || row.dataset.kind === this.segmentValue
      const hay = row.dataset.search || ""
      const hit = inSegment && (q === "" || hay.includes(q) || (digits.length >= 3 && hay.includes(digits)))
      row.hidden = !hit
      if (hit) shown++
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = shown > 0
  }

  rows() { return this.hasListTarget ? [...this.listTarget.querySelectorAll("[data-kind]")] : [] }
}
